import { CardTest } from "../styles/Card";

const ViewNumberThree = ({ formInvest, setFormInvest }) => {
  // Choice One
  const onChangeChoiceOne = (e) => {
    let value = e.target.value;
    if (value === "one") {
      setFormInvest({
        ...formInvest,
        three_question_choice_one: true,
        three_question_choice_two: false,
        three_question_choice_three: false,
        three_question_choice_four: false,
      });
    }
  };

  // Choice Two
  const onChangeChoiceTwo = (e) => {
    let value = e.target.value;
    if (value === "two") {
      setFormInvest({
        ...formInvest,
        three_question_choice_one: false,
        three_question_choice_two: true,
        three_question_choice_three: false,
        three_question_choice_four: false,
      });
    }
  };

  // Choice Three
  const onChangeChoiceThree = (e) => {
    let value = e.target.value;
    if (value === "three") {
      setFormInvest({
        ...formInvest,
        three_question_choice_one: false,
        three_question_choice_two: false,
        three_question_choice_three: true,
        three_question_choice_four: false,
      });
    }
  };

  // Choice Four
  const onChangeChoiceFour = (e) => {
    let value = e.target.value;
    if (value === "four") {
      setFormInvest({
        ...formInvest,
        three_question_choice_one: false,
        three_question_choice_two: false,
        three_question_choice_three: false,
        three_question_choice_four: true,
      });
    }
  };

  return (
    <div className=" bg-gray50 p-4 mt-5 rounded-[10px] ">
      <div className=" text-maincyan text-xs">คำถามที่ 3 จาก 10</div>
      <CardTest
        choice1={<div>มีสินทรัพย์น้อยกว่าหนี้สิน</div>}
        choice2={<div>มีสินทรัพย์เท่ากับหนี้สิน</div>}
        choice3={<div>มีสินทรัพย์มากกว่าหนี้สิน</div>}
        choice4={
          <div>
            มีความมั่นใจว่ามีเงินออมหรือเงินลงทุน
            เพียงพอสำหรับการใช้ชีวิตหลังเกษียณ อายุแล้ว
          </div>
        }
        value1={"one"}
        value2={"two"}
        value3={"three"}
        value4={"four"}
        onChange1={onChangeChoiceOne}
        onChange2={onChangeChoiceTwo}
        onChange3={onChangeChoiceThree}
        onChange4={onChangeChoiceFour}
        checked1={formInvest?.three_question_choice_one}
        checked2={formInvest?.three_question_choice_two}
        checked3={formInvest?.three_question_choice_three}
        checked4={formInvest?.three_question_choice_four}
        question="3. ท่านมีสถานภาพทางการเงินในปัจจุบันอย่างไร"
      />
    </div>
  );
};

export default ViewNumberThree;
